import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';

import Static from './static';
import { ArticleAd } from './ad';
import { truncateSentence, splitArticle } from '../utilities/formatting';

export default class ArticleData extends PureComponent {
    componentDidMount() {
        const script = document.createElement('script');
        const scriptContents = this.props.embed.match(/<script[\s\S]*?>([\s\S]*?)<\/script>/)[1];
        script.innerHTML = scriptContents;
        document.getElementById('embed').appendChild(script);
    }
    
    render() {
        const { embed, body, bodyText, title, date, pathname, uid } = this.props;

        return (
            <Static>
                <Helmet
                    title={title}
                    meta={[
                        { name: 'description', content: truncateSentence(bodyText) },
                        { property: 'og:title', content: title },
                        { property: 'og:description', content: truncateSentence(bodyText) },
                        { name: 'twitter:card', content: 'summary_large_image' }
                    ]}
                />
                <div css={{ width: '100%' }}>
                    <h1 css={{ marginTop: 0, marginBottom: 4 }}>{title}</h1>
                    <div css={{ display: 'flex', alignItems: 'center', flexFlow: 'wrap' }}>
                        <span css={{ color: '#c1c0c0', marginRight: 20, marginTop: 8 }}>{date}</span>
                    </div>
                    <div>
                        <div css={{ margin: '24px 0' }} id="embed" dangerouslySetInnerHTML={{ __html: embed.split('<script>')[0] }}></div>
                        <div dangerouslySetInnerHTML={{ __html: splitArticle(body)[0] }} />
                        <div css={{ marginTop: 16, marginBottom: 16 }}><ArticleAd key={pathname} /></div>
                        <div dangerouslySetInnerHTML={{ __html: splitArticle(body)[1] }} />
                    </div>
                </div>
            </Static>
        );
    }
};
